import logo from '../assets/logoH.png'

function NotFound(){
  return (
    <div className='container'>
      <div className="row mt-5">
        <img src={logo} alt='imagen' />
      </div>
      
    </div>
  )
}

export default NotFound;